import React from 'react';

export const introductionList = [
  {
    id: 1,
    Icon: (
      <img
        className="introduction-item__icon"
        src="/svg/introduction/icon-recruitment.svg"
        alt="Unlock Human Potential"
        title="Unlock Human Potential"
      />
    ),
    title: 'Unlock Human Potential',
    descriptions: [
      'Explore employees’ true potential through personality reflection tools',
      'Develop leaders to become better leaders',
      'Build stronger teams based on insights and data'
    ]
  },
  {
    id: 2,
    Icon: (
      <img
        className="introduction-item__icon"
        src="/svg/introduction/icon-recruitment.svg"
        alt="Recruitment Process"
        title="Recruitment"
      />
    ),
    title: 'Streamline your recruitment',
    descriptions: [
      'Centralize the recruitment process to find, nurture, and match better with your talents',
      'Identify and retain the right candidates use candidate insights and profile',
      'Grow internal talent pools to optimize recruitment'
    ]
  },
  {
    id: 3,
    Icon: (
      <img
        className="introduction-item__icon"
        src="/svg/introduction/icon-potential.svg"
        alt="Manage CoreHR Activities"
        title="Manage CoreHR Activities"
      />
    ),
    title: 'Manage CoreHR Activities',
    descriptions: [
      'Save time and cut down on manual tasks with bravoSUITE COREHR features',
      'Employee record management, leave management, time sheets, and payroll made simple'
    ]
  },
  {
    id: 4,
    Icon: (
      <img
        className="introduction-item__icon"
        src="/svg/introduction/icon-insights.svg"
        alt="Strengthen Employee Engagement And Satisfaction"
        title="Strengthen Employee Engagement And Satisfaction"
      />
    ),
    title: 'Strengthen Employee Engagement And Satisfaction',
    descriptions: [
      'Improve overall employee satisfaction via feedback surveys',
      'Visualize insights of your company by generating dashboards and reports for leaders to drive growth'
    ]
  }
];
